module.exports = __webpack_public_path__ + "media/favicon/favicon-16x16-30df3f52.png";